import React from 'react';
import PageTitle from '../PageTitle';
import { Helmet } from 'react-helmet';
import ContactInfo from '../ContactInfo';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Privacy Policy</title>
      </Helmet>
      <PageTitle title={'Privacy Policy'} />
      <div className="container py-5">
        <div className="privacy-policy row">
          <div className="col-12">
            <h2>Privacy Policy for I'm Your Huckleberry LLC</h2>
            <p>
              <strong>Effective Date:</strong> January 1st 2025
            </p>
            <p>
              At I'm Your Huckleberry LLC, your privacy is important to us. This Privacy Policy
              explains how we collect, use, store, and protect your personal information when you
              interact with our cleaning services, including when you visit our website, book
              services, or contact us.
            </p>

            <ol>
              <li>
                <strong>Information We Collect</strong>
                <p>We collect personal information that you provide to us directly when you:</p>
                <ul>
                  <li>Book cleaning services through our website or over the phone.</li>
                  <li>Fill out forms or surveys.</li>
                  <li>Communicate with us via email, phone, or in-person.</li>
                </ul>
                <p>The personal information we may collect includes:</p>
                <ul>
                  <li>
                    <strong>Contact Information:</strong> Name, email address, phone number, and
                    mailing address.
                  </li>
                  <li>
                    <strong>Payment Information:</strong> Credit card details or other payment
                    methods used for transactions.
                  </li>
                  <li>
                    <strong>Service Preferences:</strong> Cleaning services requested, special
                    instructions, and feedback.
                  </li>
                  <li>
                    <strong>Other Information:</strong> Any additional details you provide us
                    voluntarily, such as allergies or special requests.
                  </li>
                </ul>
              </li>

              <li>
                <strong>How We Use Your Information</strong>
                <p>We use the information we collect for the following purposes:</p>
                <ul>
                  <li>
                    To provide and fulfill cleaning services, including scheduling and
                    communication.
                  </li>
                  <li>To process payments and manage billing.</li>
                  <li>
                    To send you service reminders, updates, promotions, and other relevant
                    information about our services (you can opt-out of marketing communications at
                    any time).
                  </li>
                  <li>To improve our services based on your feedback and preferences.</li>
                  <li>
                    To comply with legal obligations, such as maintaining records for tax or
                    business purposes.
                  </li>
                </ul>
              </li>

              <li>
                <strong>How We Protect Your Information</strong>
                <p>
                  We take reasonable precautions to protect your personal information from
                  unauthorized access, alteration, or disclosure. This includes:
                </p>
                <ul>
                  <li>Secure storage of sensitive data (such as payment information).</li>
                  <li>Using encryption and secure protocols for online transactions.</li>
                  <li>
                    Limiting access to personal data within our team to those who need it to perform
                    their duties.
                  </li>
                </ul>
                <p>
                  However, please note that no method of data transmission over the internet or
                  method of electronic storage is completely secure. While we strive to protect your
                  personal information, we cannot guarantee absolute security.
                </p>
              </li>

              <li>
                <strong>Sharing Your Information</strong>
                <p>
                  We do not sell, rent, or lease your personal information to third parties.
                  However, we may share your information in the following circumstances:
                </p>
                <ul>
                  <li>
                    <strong>Service Providers:</strong> We may share your information with trusted
                    third-party vendors who assist us in delivering our services, such as payment
                    processors, customer support, or IT providers.
                  </li>
                  <li>
                    <strong>Legal Requirements:</strong> If required by law, we may disclose your
                    personal information to comply with legal processes or governmental requests.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Cookies and Tracking</strong>
                <p>
                  Our website may use cookies and similar technologies to enhance your experience.
                  These technologies collect information about how you interact with our website,
                  which helps us improve our services and tailor your user experience. You can
                  manage your cookie preferences through your browser settings.
                </p>
              </li>

              <li>
                <strong>Your Rights and Choices</strong>
                <p>
                  Depending on your location and applicable laws, you may have the following rights:
                </p>
                <ul>
                  <li>
                    <strong>Access:</strong> You can request a copy of the personal information we
                    have about you.
                  </li>
                  <li>
                    <strong>Correction:</strong> You can update or correct your personal information
                    if it is inaccurate.
                  </li>
                  <li>
                    <strong>Deletion:</strong> You can request the deletion of your personal
                    information, subject to certain exceptions (such as legal obligations).
                  </li>
                  <li>
                    <strong>Opt-Out:</strong> You can opt-out of marketing communications at any
                    time by following the unsubscribe instructions in the communication or by
                    contacting us directly.
                  </li>
                </ul>
                <p>To exercise these rights, please contact us at the contact information below.</p>
              </li>

              <li>
                <strong>Changes to This Privacy Policy</strong>
                <p>
                  We reserve the right to update or modify this Privacy Policy at any time. Any
                  changes will be reflected by the updated "Effective Date" at the top of this
                  policy. We encourage you to review this policy periodically to stay informed about
                  how we are protecting your information.
                </p>
              </li>

              <li>
                <strong>Contact Us</strong>
                <p>
                  If you have any questions, concerns, or requests related to this Privacy Policy,
                  please contact us at:
                </p>
              </li>
            </ol>
            <ContactInfo />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
